import { useState, useEffect } from "react";

/** Detect current viewport size (respects browser zoom & OS scaling where supported) */
export function useViewportSize() {
  const [size, setSize] = useState<{ vw: number; vh: number }>({
    vw: 0,
    vh: 0,
  });

  useEffect(() => {
    const update = () => {
      const vv = (window as any).visualViewport as VisualViewport | undefined;
      setSize({
        vw: vv?.width ?? window.innerWidth,
        vh: vv?.height ?? window.innerHeight,
      });
    };
    update();

    window.addEventListener("resize", update);
    window.visualViewport?.addEventListener("resize", update);

    const mq = window.matchMedia?.(
      `(resolution: ${window.devicePixelRatio}dppx)`
    );
    mq?.addEventListener?.("change", update);

    return () => {
      window.removeEventListener("resize", update);
      window.visualViewport?.removeEventListener("resize", update);
      mq?.removeEventListener?.("change", update);
    };
  }, []);

  return size;
}
